import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/userPrograms')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/userProgram' })
  },
})
